import { Link } from 'react-router-dom';

export default function Footer() {
  const popularCards = [
    { name: '三井住友カード（NL）', path: '/mitsui' },
    { name: 'ECモール系カード', path: '/ec-mall-card' },
    { name: 'JACCSカード', path: '/jaccs' },
    { name: 'dカード', path: '/dcard' }
  ];

  const categories = [
    { name: '年会費無料', path: '/free' },
    { name: '高還元率', path: '/highreturn' },
    { name: '即日発行', path: '/instant' },
    { name: '学生向け', path: '/student' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-bank-card-line text-orange-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
              <span className="text-lg font-bold">クレジットカード比較ナビ</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              あなたにぴったりのクレジットカードを見つけるお手伝いをします。
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">人気カード</h3>
            <ul className="space-y-2">
              {popularCards.map((card, index) => (
                <li key={index}>
                  <Link
                    to={card.path}
                    className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer whitespace-nowrap"
                  >
                    {card.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">カテゴリー</h3>
            <ul className="space-y-2">
              {categories.map((category, index) => (
                <li key={index}>
                  <Link
                    to={category.path}
                    className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer whitespace-nowrap"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">サイト情報</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sitemap" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer whitespace-nowrap">
                  サイトマップ
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer whitespace-nowrap">
                  記事一覧
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <p className="text-center text-gray-400 text-sm">
            © 2024 クレジットカード比較ナビ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
